import React, { Fragment } from "react";
import { Label } from "./InputFiled1Style";
import styled from "styled-components";
export const InputField1 = ({
  name,
  type,
  label,
  onChange,
  placeholder,
  className,
  id,
  value,
  readonly,
  important,
  long,
  maxLenght,
  handleClick,
  refInput,
  style,
  defaultValue,
  onKeyPress,
}) => {
  return (
    <InputStyle>
      <Label htmlFor={name}>{label}</Label>
      <input
        style={style}
        ref={refInput}
        id={id}
        type={type}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        className={"form-control"}
        value={value}
        onClick={handleClick}
        readOnly={readonly}
        onLoad={onChange}
        maxLength={maxLenght}
        defaultValue={defaultValue}
        onKeyPress={onKeyPress}
      ></input>
    </InputStyle>
  );
};
export const InputStyle = styled.div`
  input {
    background-color: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};

    &:focus {
      background-color: ${({ theme }) => theme.box} !important;
      box-shadow: none;
      color: ${({ theme }) => theme.text};
    }
  }
`;
